import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Autocomplete
} from '@mui/material'
import CustomTypography from '../../globalStyles/fonts'
import CloseIcon from '@mui/icons-material/Close'
import { toast } from 'react-toastify'
import { shippingServiceService } from '../../utils/services/shippingService'
import ClientAutocomplete from '../clientAutocomplete'

const ShippingServiceModal = ({ open, handleClose, onAddData, selectedService }) => {
  const [shippingServiceDetails, setShippingServiceDetails] = useState({
    service: '',
    country: '',
    entry_point: '',
    exit_point: '',
    max_weight: '',
    min_weight: ''
  })
  const [selectedClient, setSelectedClient] = useState(null)
  const [shippingServiceData, setShippingServiceData] = useState([])
  const [providers, setProviders] = useState([])
  const [formErrors, setFormErrors] = useState({})
  const clientId = localStorage.getItem('client_id')
  console.log(selectedService)
  useEffect(() => {
    if (selectedService) {
      setShippingServiceDetails({
        country: selectedService.country || '',
        service: selectedService.service || '',
        entry_point: selectedService.entry_point || '',
        exit_point: selectedService.exit_point || '',
        max_weight: selectedService.max_weight || '',
        min_weight: selectedService.min_weight || ''
      })
    } else {
      resetForm()
    }
  }, [selectedService])

  const resetForm = () => {
    setShippingServiceDetails({
      service: '',
      country: '',
      entry_point: '',
      exit_point: '',
      max_weight: '',
      min_weight: ''
    })
    setFormErrors({})
  }

  const validateForm = () => {
    const errors = {}
    if (!shippingServiceDetails.country) errors.country = 'country is required.'
    if (!shippingServiceDetails.service) errors.service = 'Service is required.'
    if (!shippingServiceDetails.entry_point) errors.entry_point = 'Entry Point is required.'
    if (!shippingServiceDetails.exit_point) errors.exit_point = 'Exit Point is required.'
    if (!shippingServiceDetails.max_weight) errors.max_weight = 'Max Weight is required.'
    if (!shippingServiceDetails.min_weight) errors.min_weight = 'Min Weight is required.'
    setFormErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setShippingServiceDetails((prev) => ({ ...prev, [name]: value }))
  }

  const handleSaveOrEdit = async (e) => {
    e.preventDefault()
    if (!validateForm()) return
    try {
      if (selectedService) {
        await shippingServiceService.edit(
          {
            country: shippingServiceDetails.country,
            service: shippingServiceDetails.service,
            entry_point: shippingServiceDetails.entry_point,
            exit_point: shippingServiceDetails.exit_point,
            min_weight: shippingServiceDetails.min_weight,
            max_weight: shippingServiceDetails.max_weight
          },
          selectedService._id
        )
        toast.success('Service edited successfully!')
      } else {
        await shippingServiceService.create({
          country: shippingServiceDetails.country,
          service: shippingServiceDetails.service,
          entry_point: shippingServiceDetails.entry_point,
          exit_point: shippingServiceDetails.exit_point,
          min_weight: shippingServiceDetails.min_weight,
          max_weight: shippingServiceDetails.max_weight
        })
        toast.success('Service created successfully!')
      }
      onAddData && onAddData()
      handleClose()
    } catch (error) {
      console.error('Error saving data:', error)
      toast.error('Failed to save Shipping Service Map.')
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" aria-labelledby="form-dialog-title">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <DialogTitle id="form-dialog-title">
          {selectedService ? 'Edit Shipping Service' : 'Create Shipping Service'}
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={clientId ? 12 : 6}>
            <CustomTypography>Service</CustomTypography>
            <TextField
              sx={{ marginTop: 1 }}
              size="small"
              name="service"
              value={shippingServiceDetails.service}
              onChange={handleInputChange}
              fullWidth
              error={!!formErrors.service}
              helperText={formErrors.service}
            />
          </Grid>
          <Grid item xs={12} sm={clientId ? 12 : 6}>
            <CustomTypography>Country</CustomTypography>
            <TextField
              sx={{ marginTop: 1 }}
              size="small"
              name="country"
              value={shippingServiceDetails.country}
              onChange={handleInputChange}
              fullWidth
              error={!!formErrors.country}
              helperText={formErrors.country}
            />
          </Grid>
          <Grid item xs={12} sm={clientId ? 12 : 6}>
            <CustomTypography>Entry Point</CustomTypography>
            <TextField
              sx={{ marginTop: 1 }}
              size="small"
              name="entry_point"
              value={shippingServiceDetails.entry_point}
              onChange={handleInputChange}
              fullWidth
              error={!!formErrors.entry_point}
              helperText={formErrors.entry_point}
            />
          </Grid>
          <Grid item xs={12} sm={clientId ? 12 : 6}>
            <CustomTypography>Exit Point</CustomTypography>
            <TextField
              sx={{ marginTop: 1 }}
              size="small"
              name="exit_point"
              value={shippingServiceDetails.exit_point}
              onChange={handleInputChange}
              fullWidth
              error={!!formErrors.exit_point}
              helperText={formErrors.exit_point}
            />
          </Grid>
          <Grid item xs={12} sm={clientId ? 12 : 6}>
            <CustomTypography>{`Min Weight (g)`}</CustomTypography>
            <TextField
              sx={{ marginTop: 1 }}
              size="small"
              name="min_weight"
              value={shippingServiceDetails.min_weight}
              onChange={handleInputChange}
              fullWidth
              error={!!formErrors.min_weight}
              helperText={formErrors.min_weight}
            />
          </Grid>
          <Grid item xs={12} sm={clientId ? 12 : 6}>
            <CustomTypography>{`Max Weight (g)`}</CustomTypography>
            <TextField
              sx={{ marginTop: 1 }}
              size="small"
              name="max_weight"
              value={shippingServiceDetails.max_weight}
              onChange={handleInputChange}
              fullWidth
              error={!!formErrors.max_weight}
              helperText={formErrors.max_weight}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSaveOrEdit} variant="contained">
          {selectedService ? 'Save' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ShippingServiceModal
